export default "__VITE_ASSET__T61WGS36__"